<template>
  <div style="display: inline-block;">
    <el-dropdown trigger="click" style="margin-left: 10px;">
      <span class="el-dropdown-link">
        <el-button>
          批量上传<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in importTemplateList" :key="item.code">
          <span class="template-text" @click="importBtn(item)">{{item.templateName}}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="importDialog"
      :title="`导入${templateData.templateName}`"
      width="75%"
    >
      <el-row class="import-table">
        <ImportData
          ref="ImportData"
          importName="file"
          :importParams="{
            templateCode: templateData.templateCode
          }"
          :excelName="`${templateData.templateName}.xlsx`"
          :uploadUrl="uploadUrl"
          :downloadUrl="templateData.url"
          :tableData="uploadData"
          :uploadBtnDisabled="uploadData.length === 0"
          @submit="submit"
          @returnData="returnData"
        ></ImportData>
      </el-row>
      <WxeTable
        ref="wxeTable"
        :tableData="tableData"
        :tableHead="tableHead"
        :loading="tableLoading"
        @wxe-table-select="importTableChange"
      />
      <span slot="footer">
        <el-button type="primary" @click="importDialog=false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImportData from '@/components/ImportData';
import WxeTable from '@/components/ImportData/WxeTable.vue';

export default {
  components: { ImportData, WxeTable },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_CML_BASE_URL + 'pdLibrary/importPreview',
      importDialog: false,
      importTemplateList: [],
      templateData: {},
      tableHead: [
        { prop: 'errorMsg', label: '错误信息' },
        { prop: 'productName', label: '产品名称' },
      ],
      tableData: [],
      tableLoading: false,
      uploadData: []
    };
  },
  props: {
  },
  watch: {
    importTable(val) {
      if (val.length === 0) this.$refs.import.fileList = [];
    },
  },
  mounted () {
    this.getImportTemplateList();
  },
  methods: {
    importBtn (item) {
      this.importDialog = true;
      this.templateData = item;
      this.tableData = [];
    },
    getImportTemplateList () {
      this.$http.pdLibrary.getPdImportTemplateUrl().then(result => {
        this.importTemplateList = result.data;
      }).catch(err => {
        this.$message.error(err.msg);
      });
    },
    returnData (arr) {
      this.tableData = arr;
    },
    submit () {
      this.$http.pdLibrary.pdLibraryImportDatas({
        templateCode: this.templateData.templateCode,
        datas: this.uploadData
      }).then(() => {
        this.$message.success('导入成功');
        this.importDialog = false;
        this.$emit('importSuccess');
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.$refs.ImportData.loading = false;
      });
    },
    importTableChange (arr) {
      this.uploadData = arr;
    }
  },
};
</script>

<style lang="less" scoped>
.import-table {
  display: flex;
  align-items: center;
  margin-top: -20px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
.template-text {
  display: inline-block;
  width: 100%;
}
</style>
